import {computed} from "vue";

export default function PricingParse(selectedOptions) {
	const getPriceIngredient = computed(() => {
		var priceFrame = {};
		var priceSize = {};

		var productType = selectedOptions.product_finish.value;
		var posterFrame = selectedOptions.poster_frame.value;

		Object.keys(nse_config.pricing).map((size) => {
			var priceF = +nse_config.pricing[size].frame;
			if (posterFrame.toString() === 'none' || productType.toString() !== 'poster') {
				priceSize[size] = nse_number_format.to(+nse_config.pricing[size].type[productType])
			} else {
				priceSize[size] = nse_number_format.to(+nse_config.pricing[size].type[`${productType}_f`] - (+priceF))
			}

			priceFrame[size] = nse_number_format.to(priceF);
		})

		return {
			poster_frame: priceFrame,
			size: priceSize
		};
	});

	const getPrice = computed(() => {
		var price = 0;

		var productType = selectedOptions.product_finish.value;
		var posterSize  = selectedOptions.poster_size.value;
		var posterFrame = selectedOptions.poster_frame.value;

		var priceTotal  = nse_config.pricing[posterSize];


		if (posterFrame.toString() === 'none' || productType.toString() !== 'poster') {
			if (priceTotal.type && priceTotal.type[productType]) {
				price = (priceTotal.type[productType])
			}
		} else {
			if (priceTotal.type && priceTotal.type[`${productType}_f`]) {
				price = (priceTotal.type[`${productType}_f`])
			}
		}

		var numberToFormat = Math.pow(10, window.nse_config.product_info.number_of_decimal)
		price = (Math.round(price * numberToFormat) / numberToFormat).toFixed(window.nse_config.product_info.number_of_decimal);


		price = +price;
		price = nse_number_format.to(price);

		return {
			total: price,
		};
	});

	return {
		getPrice,
		getPriceIngredient
	}
}
